import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5528 3.10557C14.8343 2.9648 15.1657 2.96481 15.4473 3.10561L20.894 5.82947C21.2262 5.99545 21.5056 6.25062 21.7009 6.56641C21.8962 6.88221 21.9998 7.24615 22 7.61747V18.382C21.9998 18.7228 21.9126 19.0584 21.7465 19.356C21.5805 19.6536 21.3411 19.9038 21.0512 20.0829C20.7613 20.262 20.4304 20.3641 20.09 20.3794C19.7495 20.3948 19.4108 20.3229 19.106 20.1705L15 18.118L9.44721 20.8944C9.16566 21.0352 8.83426 21.0352 8.55272 20.8944L3.106 18.1705C2.77384 18.0046 2.49444 17.7494 2.2991 17.4336C2.10377 17.1178 2.0002 16.7539 2 16.3825L2 5.618C2.00018 5.27722 2.08744 4.9416 2.25349 4.64401C2.41954 4.34642 2.65888 4.09619 2.94879 3.91708C3.2387 3.73796 3.56957 3.63589 3.91001 3.62056C4.25045 3.60523 4.58916 3.67714 4.894 3.82947L8.99995 5.88199L14.5528 3.10557ZM8 7.61809L4 5.61853V16.3815L8 18.3818V7.61809ZM10 18.382L14 16.382V5.61803L10 7.61803V18.382ZM16 5.61817V16.3819L20 18.3815V7.61853L16 5.61817Z"
    />
  </svg>
);

const MapIcon = (props) => <Icon component={SVG} {...props} />;

export default MapIcon;
